<template>
  <van-swipe-cell>
    <div class="main-item"
      @click="showDetail(data)">
      <div class="level1">
        <div class="item-img">
          <van-image width="2.875rem"
            height="2.875rem"
            :src="data.userProfile.photoBase64" />
        </div>
        <div class="item-info">
          <div class="item-head">
            <div class="head-name"
              v-text="data.userProfileName"></div>
          </div>
          <div class="item-position">
            <span v-text="data.userProfile.los"></span>/
            <span v-text="data.userProfile.city"></span>/
            <span v-text="data.userProfile.jobTitle"></span>
          </div>
        </div>
        <div class="div-chk"
          v-show="showChk">
          <van-checkbox v-model="data.checked"
            checked-color="#c52a1a"></van-checkbox>
        </div>
      </div>

      <div class="level2">
        <div class="div-icon">
          <div class="div-line"></div>
          <div class="div-dot"></div>
        </div>
        <div class="flex-row content">
          <div class="pe-img">
            <van-image width="2.5rem"
              height="2.5rem"
              :src="data.logo" />
          </div>
          <div class="pe-info">
            <label class="contact-info">{{ data.peContactName }}</label>
            <div class="deep-info">
              <span>关系深度: </span>
              <div class="rel-deep">{{
                data.relationDeepth
              }}</div>
              &nbsp;&nbsp;|&nbsp;&nbsp; 关联<span style="color: #d04a02">{{
                data.contractorNumbers
              }}</span><span>位合伙人</span>
            </div>
            <div class="org-info">
              <span>{{ data.peOrganizationName }}</span><span v-if="data.responsibility != null">&nbsp;·&nbsp;</span><span>{{ data.responsibility }}</span><span v-if="data.position != null">&nbsp;·&nbsp;</span><span>{{ data.position }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #right>
      <div class="cell-right"
        @click="cancelMark(data.id)">
        &nbsp;&nbsp; 取消收藏&nbsp;&nbsp;
      </div>
    </template>
  </van-swipe-cell>
</template>

<script>
import { Dialog } from "vant";
import RelationshipItem from "@components/common/RelationshipItem.vue";
import userInfo from "@common/loginInfo";

export default {
  data () {
    return {
      userId: userInfo.userToken.userId,
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    showChk: {
      type: Boolean,
      required: false,
    },
    isCollect: {
      type: Number,
      default: 1
    }
  },
  components: {
    RelationshipItem,
  },

  computed: {},

  mounted () { },

  methods: {
    cancelMark (id) {
      Dialog.confirm({
        title: "提示",
        message: "确认取消收藏该关系",
      })
        .then(() => {
          //request
          this.$emit("cancel", id);
        })
        .catch(() => {
          // on cancel
        });
    },
    showDetail (item) {
      if (!this.showChk) {
        this.$router.push({
          path: "/relationshipDetail",
          query: {
            id: item.id,
            userId: this.userId,
            isCollect: this.isCollect
          },
        });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.main-item {
  padding: 0.5rem 0 0 1rem;
  border-bottom: 6px solid #f2f2f2;
  position: relative;
  height: 150px;

  .level1 {
    display: flex;

    .item-img {
      padding: 0.25rem;
    }

    .item-info {
      padding: 0.25rem;
      flex: 1;
      .item-head {
        display: flex;
        .head-name {
          color: #464646;
          font-size: 0.875rem;
          font-weight: bolder;
          width: 70%;
        }
      }
      .item-prefer,
      .item-position {
        padding: 0.25rem 0;
        color: #7d7d7d;
        font-size: 0.75rem;
        line-height: 2rem;
        padding-bottom: 2px;
        //word-break: keep-all;
      }
    }

    .div-chk {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .level2 {
    position: relative;
    display: flex;
    margin-top: 0.625rem;
    // .content {
    //   position: absolute;
    //   left: 76px;
    // }

    .div-icon {
      width: 60px;
      position: relative;

      .div-line {
        display: inline-block;
        width: 1px;
        height: 2.5rem;
        background-color: #dedede;
        position: absolute;
        left: 50%;
        top: calc(25% - 2.5rem);
        z-index: -99;
      }
      .div-dot {
        display: inline-block;
        width: 9px;
        height: 9px;
        background-color: #dedede;
        position: absolute;
        left: 50%;
        top: 25%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .content {
      flex: 1;
      .pe-info {
        padding-left: 0.5rem;

        .contact-info {
          font-size: 0.875rem;
          font-weight: bold;
        }
        .deep-info {
          font-size: 0.75rem;
          color: #7d7d7d;
          height: 1.625rem;
          line-height: 1.625rem;

          .rel-deep {
            color: #c52a1a;
            text-overflow: ellipsis;
            max-width: 2.5rem;
            overflow: hidden;
            display: inline-block;
            vertical-align: bottom;
            white-space: nowrap;
          }
        }
        .org-info {
          font-family: PingFangSC-Regular;
          color: #2d2d2d;
          font-size: 0.8125rem;
        }
      }
    }
  }
}
.cell-right {
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  // background-color: #7d7d7d;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/content/relation/RelationItem.vue